/**
 * Copyright (c) 2023 ForgeRock. All rights reserved.
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */

export const blankValueIndicator = '--';

/**
 * Admin permissions in the reviewers modal for access reviews
 */
export const ADMIN_REVIEWER_PERMISSIONS = {
  certify: true,
  comment: true,
  exception: true,
  forward: true,
  reassign: true,
  reset: true,
  revoke: true,
  signoff: true,
};
